import { useSelector } from "react-redux";
import { useQuery } from "react-query";

import { appState } from "$reducers";
import { getOpsWithParcelAndNoShippingRecord } from "$services/Op.service";
import { CacheInvalidationAction } from "$utils/cache";

const useShippingOps = (page: number, pageSize: number, filters: any) => {
  const { filter: company } = useSelector(appState);
  const { data: { ops, total } = { ops: [], total: 0 }, isLoading } = useQuery(
    [
      CacheInvalidationAction.GET_OPS_WITH_PARCEL_AND_NO_SHIPPING_RECORD,
      {
        ...(company ? { company: company._id } : {}),
        page,
        pageSize,
        ...filters,
      },
    ],
    () =>
      getOpsWithParcelAndNoShippingRecord({
        ...(company ? { company: company._id } : {}),
        page,
        pageSize,
        ...filters,
      }),
    {
      cacheTime: 5 * 60 * 1000,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    }
  );

  return {
    ops,
    isLoading,
    total,
  };
};

export default useShippingOps;
